import React from 'react';
import TrialModal from './TrialModal';
import SubscriptionSuccessModal from './SubscriptionSuccessModal';
import AccountModal from './AccountModal';
import BillingModal from './BillingModal';
import CancelModal from './CancelModal';
import LogoutModal from './LogoutModal';
import DiscountModal from './DiscountModal';
import DiscountConfirmationModal from './DiscountConfirmationModal';
import CancellationConfirmationModal from './CancellationConfirmationModal';
import UpdatePaymentModal from './UpdatePaymentModal';

const ModalManager = () => (
  <>
    <TrialModal />
    <SubscriptionSuccessModal />
    <AccountModal />
    <BillingModal />
    <CancelModal />
    <LogoutModal />
    <DiscountModal />
    <DiscountConfirmationModal />
    <CancellationConfirmationModal />
    <UpdatePaymentModal />
  </>
);

export default ModalManager;
